import React from 'react';
import dcgLogo from '../../../assets/img/brand/dcg_logo_header.png';
import { HeaderAndBodyLayout } from '../../../utilities/dcgAutomationPageCommonImports';
import SubscriptionConfirmationPageContent from '../PageContent/SubscriptionConfirmationPageContent';


const SubscriptionConfirmation = () => {
    return (
        <HeaderAndBodyLayout headerLogo={dcgLogo} containerSize="md" backButton={false}>
            <SubscriptionConfirmationPageContent hasLicense={true} />
        </HeaderAndBodyLayout>
    );
};

export default SubscriptionConfirmation;

